import { render, staticRenderFns } from "./ClientFormKyb.vue?vue&type=template&id=13405ab0&scoped=true"
import script from "./ClientFormKyb.vue?vue&type=script&lang=js"
export * from "./ClientFormKyb.vue?vue&type=script&lang=js"
import style0 from "./ClientFormKyb.vue?vue&type=style&index=0&id=13405ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13405ab0",
  null
  
)

export default component.exports